function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHome4R({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 452,
    height: 521,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#EFF3EE",
    d: "M121.752 311.011c10.464 11.832 24.909 20.302 38.107 29.065 13.198 8.764 27.709 15.558 43.134 20.861 15.142 5.242 30.734 11.144 46.689 12.62 15.956 1.477 32.934 2.329 48.573-.205 13.485-2.154 27.609-7.267 41.428-8.224 14.724-1.042 26.997 1.046 38.665 10.042 14.654 11.612 23.847 27.956 29.299 45.181 5.01 15.159 11.725 29.279 20.992 42.542 9.549 13.324 17.619 28.018 31.324 37.172 13.706 9.155 29.855 16.585 46.426 19.32 16.572 2.735 33.182-1.559 48.895-7.174 17.64-6.324 35.463-14.861 48.105-28.178 11.96-12.9 20.543-29.346 28.162-45.436 7.618-16.091 8.793-33.855 10.134-51.021 1.399-17.434 2.232-34.99-4.184-51.861-6.191-16.54-19.482-28.983-32.889-40.888-13.69-11.967-27.828-24.593-45.182-29.187-17.636-4.654-36.776-3.721-54.359 2.334-15.654 5.346-29.875 17.758-45.255 24.57-17.025 7.584-35.316 8.7-51.457-.136-12.474-6.636-21.067-18.909-27.623-31.024-6.78-12.444-13.561-24.889-20.001-37.541-6.78-12.445-12.256-25.452-19.036-37.897-8.461-15.622-17.712-31.698-27.878-46.281-10.39-14.913-22.201-28.726-37.312-39.592-12.799-9.24-28.123-12.27-43.614-15.897-15.208-3.567-30.416-7.134-45.939-5.138-15.747 1.666-29.313 8.307-43.221 15.156-13.907 6.849-30.743 10.814-40.599 22.198-11.736 13.231-14.78 31.435-18.666 48.051-3.545 16.408-6.698 33.745-3.907 50.958 2.509 17.152 6.09 34.818 13.304 50.735 6.591 16.063 16.407 32.26 27.885 44.875Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#c1e4d1",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ACF6E4",
    d: "m16.977 80.522 32.235-23.248L83.92 38.36l39.326-6.552 37.393 10.567 36.318 12.47 29.227-9.933 23.209-21.03L282.379.952 322.781 0l32.879 23.248 35.889 12.046 36.64-20.289 32.665-10.884 33.74 8.665 24.928 24.622 20.416 37.62 19.556 38.252-40.079.74-39.972-2.113-39.971-2.114-40.079-.634-40.079 1.479-39.972-.528-40.079-.951-39.971-.74h-40.079l-39.972-1.373h-40.079l-39.971-2.748-40.08.212L0 103.241l16.977-22.719Z",
    style: {
      fill: "#c1e4d1",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome4R);
export default __webpack_public_path__ + "static/media/bg_home4_r.5b0d0ca3a9784c5f1cef11618b062f72.svg";
export { ForwardRef as ReactComponent };